function normalizeGclid(value) {
    if (typeof value !== 'string') return '';
    const cleaned = value.trim();
    return cleaned === 'null' || cleaned === 'undefined' ? '' : cleaned;
}

export default function resolveGclid() {
    const urlParams = new URLSearchParams(window.location.search);
    const gclidKey = Array.from(urlParams.keys()).find(key => key.toLowerCase() === 'gclid');
    if (gclidKey !== undefined) {
        const value = normalizeGclid(urlParams.get(gclidKey));
        try {
            localStorage.setItem('gclid', value);
        }
        catch {
            // URL attribution remains usable when browser storage is unavailable.
        }
        return value;
    }

    try {
        const stored = normalizeGclid(localStorage.getItem('gclid'));
        if (stored.startsWith('{')) {
            return normalizeGclid(JSON.parse(stored)?.value);
        }
        return stored;
    }
    catch {
        return '';
    }
}
